export default __webpack_public_path__ + "static/media/Glicpix_preview.36fa4a41.gif";